<template>
  <div id="order-ai-container-edit">
    <iframe
      frameborder="1"
      width="100%"
      :height="`${height}px`"
      scrolling="no"
      :src="`${VUE_APP_BASE_AUTH_MODULE}/order/data-order-ai/${id}/edit`"
      allow="clipboard-read; clipboard-write"
    />
  </div>
</template>
<script>

export default {
  data() {
    return {
      VUE_APP_BASE_AUTH_MODULE: process.env.VUE_APP_BASE_AUTH_MODULE,
      dataOrder: {},
      height: 0,
      url: '',
      id: this.$route.params.id,
    }
  },
  mounted() {
    window.addEventListener('message', event => {
      if (event.origin === this.VUE_APP_BASE_AUTH_MODULE) {
        const {
          type, data, route,
        } = event.data
        if (type === 'SET_DIMENSION') {
          this.height = Math.floor(data.height)
        }
        if (type === 'route') {
          this.$router.push(route)
        }
      }
    })
  },
}
</script>
